import { render } from "./ImpersonatePromo.vue?vue&type=template&id=65ef0aba&scoped=true"
import script from "./ImpersonatePromo.vue?vue&type=script&lang=js"
export * from "./ImpersonatePromo.vue?vue&type=script&lang=js"

import "./ImpersonatePromo.vue?vue&type=style&index=0&id=65ef0aba&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-65ef0aba"]])

export default __exports__